import { parseEnSelectionFilter } from '../../../../data/selection/selectionEnFilters';
import { jsonReplaceDbActionVariables } from '../helpers/jsonReplaceVariables';
import { TpDashboardActionContext, TpDbActionStepDefinition as TpDbActionStepTypeDefinition } from '../interfaces';

function getJsonSchema(): any {
  return {
    type: 'object',
    title: 'Set Chart Filter ',
    description: 'Specifies a filter that is applied on an individual chart and replaces any existing filter.',
    properties: {
      type: { type: 'string', const: 'SetChartFilter' },
      chartId: {
        type: 'string',
        description: 'Identifier of the chart in the dashboad template for which the filter should be set.',
      },
      filter: {
        type: 'object',
        description:
          'Definition of the filter to be displayed. See /elements/widgets for more information. Note that this can only be used for charts on a dashboard that are defined in a direct way in the template (and not e.g. via a gallery plot compound element). Note that this definition can refer to variables created earlier via "$VariableName".',
      },
    },
    required: ['type', 'chartId', 'filter'],
  };
}

function execute(ctx: TpDashboardActionContext, step: any, onCompleted: () => void) {
  const filterDef = jsonReplaceDbActionVariables(ctx, step.filter);
  const chartTemplateId = step.chartId; // in the template action definition, the user enters the same chart id as for the definition of the chart in the template
  const chartDefs = ctx.dashboardContext.getChartDefsFromTemplateId(chartTemplateId);
  chartDefs.forEach((chartDef) => {
    const dataTableId = chartDef.dataBinding.dataTableId;
    const filter = parseEnSelectionFilter(ctx.dataContext, dataTableId, filterDef);
    ctx.dashboardContext.updateSingleChartFilter(chartDef.id, filter);
  });
  onCompleted();
}

const dbActionStepSetChartFilter: TpDbActionStepTypeDefinition = {
  stepType: 'SetChartFilter',
  execute,
  getJsonSchema,
};

export default dbActionStepSetChartFilter;
